<template>
  <td
    class="sb-table-cell"
    data-sb-regression="sb-table-cell"
    :class="`sb-table-cell--${contentAlignment}`"
    v-bind="$attrs"
    :width="width"
  >
    <div class="sb-table-cell-container">
      <!--
        @slot slot to show table cell contents
      -->
      <slot />
    </div>
  </td>
</template>
<script>
const indexOfMultiple = (value, matches) => {
  return matches.some((m) => value.indexOf(m) !== -1);
};

export default {
  name: 'SbTableCell',
  props: {
    contentAlignment: {
      type: String,
      default: 'center',
      validator: (value) => value.match(/(top|center|bottom)/),
    },
    width: {
      type: String,
      default: 'auto',
      validator: (value) => indexOfMultiple(value, ['px', '%', 'auto', 'inherit', 'default']),
    },
  },
};
</script>
<style lang="scss">
@import '@src/components/Table/style/sb-table-cell.scss';
</style>
